import $ from "jquery";
import {AppConfig} from "../AppConfig";
import Cookies from 'universal-cookie';

const cookies = new Cookies();

export function WebService(){
    this.post = function(_url,_data,result,_error){
        $.ajax({
            url: _url,
            //headers: {'Authorization':AppConfig.auth.type+" "},
            contentType: "application/json;charset=iso-8859-9",
            type: "POST",
            dataType:"json",
            data: _data,
            success: result,
            error: function(xhr, status, error,) {
                if(_error!=null && _error instanceof Function)
                    _error(xhr.status + ': ' + xhr.statusText);
            }
        });

    };


    this.postWithToken = function(_url,_data,result,_error){
        $.ajax({
            url: _url,
            headers: {'Authorization':AppConfig.auth.type+" "+cookies.get(AppConfig.cookie.token)},
            contentType: "application/json;charset=iso-8859-9",
            type: "POST",
            dataType:"json",
            data: _data,
            success: result,
            error: function(xhr, status, error,) {
                //const errorMessage = xhr.status + ': ' + xhr.statusText;
                if(xhr.status===401){
                    //alert("Token Expired. Please Sing In")
                    cookies.remove(AppConfig.cookie.name,{path:"/"});
                    cookies.remove(AppConfig.cookie.surname,{path:"/"});
                    cookies.remove(AppConfig.cookie.token,{path:"/"});
                    window.location.replace(AppConfig.pages.login);
                }
                /*else
                    alert('My Error - ' + xhr.status + "__" + errorMessage);*/

                if(_error!=null && _error instanceof Function)
                    _error(status);
            }
        });
    };

    this.getWithToken = function(_url,result,_error){
        $.ajax({
            url: _url,
            headers: {'Authorization':AppConfig.auth.type+" "+cookies.get(AppConfig.cookie.token)},
            contentType: "application/json;charset=iso-8859-9",
            type: 'GET',
            dataType:"json",
            success: result,
            error: function(xhr, status, error,) {
                const errorMessage = xhr.status + ': ' + xhr.statusText;
                if(xhr.status===401){
                    //alert("Token Expired. Please Sing In")
                    cookies.remove(AppConfig.cookie.name,{path:"/"});
                    cookies.remove(AppConfig.cookie.surname,{path:"/"});
                    cookies.remove(AppConfig.cookie.token,{path:"/"});
                    window.location.replace(AppConfig.pages.login);
                }
                else
                    alert('My Error - ' + xhr.status + "__" + errorMessage);

                if(_error!=null && _error instanceof Function)
                    _error(status);
            }
        });
    };
}
